<template>
  <div>
    <v-dialog v-model="showDialog" width="1200px" class="pa-0 ma-0">
      <v-card style="min-height: 60vh">
        <v-toolbar class="primary" dark
          >Relatório de razão
          <v-spacer></v-spacer>
          <v-btn color="white" text @click="closeModal"> x </v-btn></v-toolbar
        >

        <v-card-text>
          <v-progress-circular
            v-show="loading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <br />
          <v-row>
            <v-spacer></v-spacer>
            <v-btn class="white" @click="exportToExcel()"
              ><v-icon color="green">mdi-microsoft-excel</v-icon
              ><v-icon color="green">mdi-download</v-icon></v-btn
            >
          </v-row>
          <br />
          <v-simple-table>
            <thead>
              <tr>
                <th class="subheading font-weight-light text-center">
                  Código reduzido
                </th>
                <th class="subheading font-weight-light text-center">Conta</th>
                <th class="subheading font-weight-light text-center">
                  Descrição
                </th>
                <th class="subheading font-weight-light text-center">Débito</th>
                <th class="subheading font-weight-light text-center">
                  Crédito
                </th>
                <th class="subheading font-weight-light text-center">
                  Diferença
                </th>
              </tr>
            </thead>
            <tbody class="text-center">
              <tr v-for="(razaoItem, index) in razaoItems" :key="index">
                <td>
                  <span>{{ razaoItem.COD_REDUZIDO }} </span>
                </td>
                <td>
                  <span>{{ razaoItem.CONTA }} </span>
                </td>
                <td>
                  <span>{{ razaoItem.DESC_CONTA }} </span>
                </td>
                <td><span v-money-format="razaoItem.VL_DEBITO"></span></td>
                <td><span v-money-format="razaoItem.VL_CREDITO"></span></td>
                <td><span v-money-format="razaoItem.VL_DIFERENCA"></span></td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import strapiApi from "../../../../libraries/strapi/strapiApi";
import { mapState } from "vuex";
import { utils, writeFile } from "xlsx";

export default {
  name: "dialog-razao",
  props: ["value", "process"],
  components: {},
  data() {
    return {
      sortBy: "createdAt",
      sortDesc: true,
      search: null,
      page: 1,
      itemsPerPage: 50,
      serverItemsLength: 15,
      nfses: [],
      razaoItems: [],
      newCommentValue: "",
      loading: false,
      expenses: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  async mounted() {},

  watch: {
    showDialog(val, oldVal) {
      if (val) {
        this.getData();
      }
    },
  },
  methods: {
    async exportToExcel() {
      let keys = [
        { key: "COD_REDUZIDO", text: "Código reduzido" },
        { key: "CONTA", text: "Conta" },
        { key: "DESC_CONTA", text: "Descrição" },
        { key: "VL_DEBITO", text: "Valor débito" },
        { key: "VL_CREDITO", text: "Valor crédito" },
        { key: "VL_DIFERENCA", text: "Valor diferença" },
      ];

      let data = this.razaoItems.map((el) => {
        const sortedObj = {};
        keys.forEach((key) => {
          sortedObj[key.text] = el[key.key];
        });
        return sortedObj;
      });

      const ws = utils.json_to_sheet(data);

      const wb = utils.book_new();

      utils.book_append_sheet(wb, ws, "Relatório de despesas");

      writeFile(wb, "Relatório de razão.xlsx");
    },

    closeModal() {
      this.showDialog = false;
    },

    async getData() {
      this.razaoItems = [];
      this.loading = true;
      let { values, pagination } =
        await strapiApi.vwFechProcRazaoItems.getWithPagination(
          1,
          25,
          "createdAt",
          false,
          this.process.PRI_COD,
          this.process.FIL_COD
        );

      if (values) {
        let totalLine = {
          DESC_CONTA: "Total",
          VL_DEBITO: values.reduce((acc, curr) => acc + curr.VL_DEBITO, 0),
          VL_CREDITO: values.reduce((acc, curr) => acc + curr.VL_CREDITO, 0),
          VL_DIFERENCA: values.reduce(
            (acc, curr) => acc + curr.VL_DIFERENCA,
            0
          ),
        };
        let sorted = values.sort(
          (a, b) => a.COD_REDUZIDO - b.COD_REDUZIDO
        );
        this.razaoItems = [...sorted, totalLine];
      }

      this.loading = false;
    },
  },
};
</script>
